import React from 'react';
import { Skeleton } from '@heroui/react';

const CommentItemSkeleton: React.FC = () => {
  return (
    <div className="flex gap-3 py-3 border-b border-secondary-100 last:border-0">
      <Skeleton className="rounded-full w-10 h-10 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between">
          <div className="flex flex-col w-full">
            <Skeleton className="h-4 w-20 mb-1 rounded-md" />
            <Skeleton className="h-5 w-32 rounded-md" />
          </div>
        </div>
        <div className="mt-2">
          <Skeleton className="h-4 w-full rounded-md" />
          <Skeleton className="h-4 w-3/4 mt-1 rounded-md" />
        </div>
      </div>
    </div>
  );
};

export default CommentItemSkeleton; 